import { defineMessages } from 'react-intl';

export default defineMessages({
  loadingMessage: {
    id: 'loading.loadingMessage',
    defaultMessage: 'Loading',
  },
});
